// NEW: UI_REVAMP
import { Flex, Image, Text } from '@chakra-ui/react';
import {
	RESULT_BALLS,
	RESULT_HEADER_GRADIENTS,
	RESULT_HEADER_TEXT_COLORS,
} from '../../constant/resultCard';
import ImgComp from '../../utils/ImgComp';
import GradientBox from '../box/GradientBox';

export const ResultCardHeader = ({ gameType }) => {
	return (
		<Flex alignItems='center' gap={2}>
			<GradientBox
				borderRadius='full'
				display='flex'
				w={{ base: 8, lg: 10 }}
				h={{ base: 8, lg: 10 }}
				justifyContent='center'
				alignItems='center'
				boxShadow='none'
				p='1px'
			>
				<Flex
					borderRadius='full'
					bg='white'
					w='full'
					h='full'
					p={gameType?.toLowerCase() !== 'mandaue' ? { base: '2px', lg: '3px' } : undefined}
					justifyContent='center'
					alignItems='center'
				>
					<ImgComp svgName={gameType.toLowerCase()} w='full' h='full' />
				</Flex>
			</GradientBox>
			<Text
				fontSize={{ base: '14px', lg: '16px' }}
				fontWeight={600}
				color='black'
				textTransform='uppercase'
			>
				{gameType}
			</Text>
		</Flex>
	);
};

const getGameBallCount = (gameType) => {
	const gt = String(gameType || '').toLowerCase();
	if (gt.includes('ez2') || gt.includes('2d')) {
		return 2;
	}
	if (gt.includes('3d') || gt.includes('swer3') || gt.includes('3')) {
		return 3;
	}
	if (gt.includes('4d') || gt.includes('4')) {
		return 4;
	}
	return 3;
};

export const ResultCardBody = ({ gameType, results, winners }) => {
	const activeResults = results || [];

	return (
		<GradientBox borderRadius='8px' p='1px'>
			<Flex w='full' bg='white' borderRadius='inherit' overflow='hidden'>
				{activeResults.map((item, idx) => {
					const hasNumbers = item.numbers && item.numbers.length > 0;
					const drawWinners = item.winners !== undefined ? item.winners : winners;

					let displayWinners = '--';
					if (
						hasNumbers &&
						drawWinners !== undefined &&
						drawWinners !== null &&
						drawWinners !== 'undefined'
					) {
						displayWinners = drawWinners.toLocaleString();
					}

					let listToMap = [];
					if (hasNumbers) {
						listToMap = item.numbers;
					} else {
						const count = getGameBallCount(gameType);
						listToMap = Array(count).fill('--');
					}

					return (
						<Flex key={idx} flex={1} direction='column' align='center'>
							{/* Column Header (Draw Time) */}
							<Flex
								w='full'
								h={{ base: '22px', lg: '35px' }}
								bgGradient={RESULT_HEADER_GRADIENTS[idx] || RESULT_HEADER_GRADIENTS[2]}
								color={RESULT_HEADER_TEXT_COLORS[idx] || 'white'}
								align='center'
								justify='center'
								fontWeight={600}
								fontSize={{ base: '12px', lg: '16px' }}
								px={3}
								py={{ base: 1, lg: 2 }}
							>
								{item.time}
							</Flex>

							{/* Column Body Container */}
							<Flex
								direction='column'
								align='center'
								justify='center'
								flex={1}
								w='full'
								py={2}
								minH={{ base: '80px', lg: '120px' }}
								gap={2}
								borderRight={idx === activeResults.length - 1 ? 'none' : '1px solid #F5D7A9'}
							>
								{/* Balls Container */}
								<Flex gap={1} justify='center' align='center' px={2}>
									{listToMap.map((num, i, arr) => {
										const ballColor = (RESULT_BALLS[arr.length] || RESULT_BALLS.default)[i];
										return (
											<Flex
												key={i}
												position='relative'
												maxW={{ base: 10, lg: '72px' }}
												maxH={{ base: 10, lg: '72px' }}
												align='center'
												justify='center'
												style={{ aspectRatio: '1 / 1' }}
											>
												<Image
													src={`/assets/img/${ballColor}-ball.png`}
													w='full'
													h='full'
													objectFit='contain'
													alt='ball'
												/>
												<Text
													position='absolute'
													top='50%'
													left='50%'
													transform='translate(-50%, -50%)'
													zIndex={2}
													fontSize={{ base: '20px', lg: '36px' }}
													fontWeight={700}
													color='#190331'
													whiteSpace='nowrap'
												>
													{num}
												</Text>
											</Flex>
										);
									})}
								</Flex>

								{/* Winners Count */}
								<Text
									fontSize={{ base: '10px', md: '14px' }}
									fontWeight={{ base: 400, lg: 500 }}
									color={{ base: '#3C3E49', lg: '383A45' }}
									whiteSpace='nowrap'
								>
									{displayWinners} winners
								</Text>
							</Flex>
						</Flex>
					);
				})}
			</Flex>{' '}
		</GradientBox>
	);
};

const ResultCard = ({ data }) => {
	if (!Array.isArray(data)) return null;

	return (
		<Flex flexDir='column' w='full' gap={2}>
			{data.map((item) => (
				<GradientBox key={item.gameType} p='1px'>
					<Flex flexDir='column' gap={3} borderRadius='inherit' py={3} px={2} bg='resultCardBg'>
						<ResultCardHeader gameType={item.gameType} />
						<ResultCardBody
							gameType={item.gameType}
							results={item.results}
							winners={item.winners}
						/>
					</Flex>
				</GradientBox>
			))}
		</Flex>
	);
};

export default ResultCard;
